
import { useSlideLayout } from '@gripp/shared-ui';
import { useEffect, useState } from 'react';
import { StyleSheet, View } from 'react-native';
import { IAccountSettings } from '../interfaces';
import { SETTINGS_ACCOUNT_SETTINGS_PAGES, SETTINGS_COLUMNS_ID } from '../settingColumns';
import { AccountPage } from './accountPage';
import { Preferences } from './preferences';
import { Profile } from './profile';

export const AccountSettings = () => {
  const { columnData, setColumnTitle } = useSlideLayout();
  const [ currentSettingPage, setCurrentSettingPage ] = useState<string | undefined>(undefined);

  useEffect(() => {
    if (columnData && columnData[SETTINGS_COLUMNS_ID.SETTINGS]) {
      const accountSettingsProps = columnData[SETTINGS_COLUMNS_ID.SETTINGS] as IAccountSettings;
      setCurrentSettingPage(accountSettingsProps.page || undefined);
    }
  }, [columnData]);

  const renderContent = () => {
    switch (currentSettingPage) {
      case SETTINGS_ACCOUNT_SETTINGS_PAGES.PROFILE:
        return <Profile />;
      case SETTINGS_ACCOUNT_SETTINGS_PAGES.PREFERENCES:
        return <Preferences />;
      default:
        return <AccountPage />;
    }
  };

  useEffect(() => {
    switch (currentSettingPage) {
      case SETTINGS_ACCOUNT_SETTINGS_PAGES.PROFILE:
        setColumnTitle(SETTINGS_COLUMNS_ID.ACCOUNT, 'preferences.settings.profile');
        break;  
      case SETTINGS_ACCOUNT_SETTINGS_PAGES.PREFERENCES:
        setColumnTitle(SETTINGS_COLUMNS_ID.ACCOUNT, 'preferences.settings.notifications');
        break;  
      default:
        setColumnTitle(SETTINGS_COLUMNS_ID.ACCOUNT, 'preferences.settings.workspace_settings');
    }
  }, [currentSettingPage, setColumnTitle]);

  return (
    <View style={styles.container}>
      {renderContent()}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    gap: 12,
    marginTop: 16,
  },
});
